import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import BenefitService from "../../services/BenefitService";
const initialState = {
  data: {},
  columnConfig: [],
  status: "idle",
  benefitByPage : {},
  formData: {
    // liability: [],
    // assets: [],
    // paymentTerm: [],
    // sequenceFormats: []
  },
};
export const fetchTotalBenefits = createAsyncThunk("benefit", async () => {
  const response = await BenefitService.getTotalBenefit();
  return response;
});

export const fetchBenefitsByPage = createAsyncThunk("benefitByPage", async () => {
  const response = await BenefitService.getBenefitBypage();
  return response;
});

export const BenefitSlice = createSlice({
  name: "benefit",
  initialState,
  reducers: {

  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTotalBenefits.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchTotalBenefits.fulfilled, (state, action) => {
        state.status = "idle";
        state.data = action.payload;
      })
      .addCase(fetchBenefitsByPage.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchBenefitsByPage.fulfilled, (state, action) => {
        state.status = "idle";
        state.benefitByPage = action.payload;
      });
  },
});

// export const { addComponentColumnConfig, addColumnToComponentColumnConfig } =
//   ComponentSlice.actions;

export const selectBenefits = (state) => {
  return state.benefit.data;
};

export const selectBenefitsByPage = (state) => {
  return state.benefit.benefitByPage;
};

// export const selectComponentColumnConfig = (state) =>
//   state.component.columnConfig;

export default BenefitSlice.reducer;
